/** 
*@author: satyamurthy.a
*@Description : 
**/
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import localStorage from "../../../utils/localStorage";
import StyledTable from "../../../commons/styles/table";
import { constant } from "../../Settings/Constants";
import { DrawerFooter } from "../../../commons/styles/layout";
import { API_DEVICE, API_HIERARCHYMODULE, IPAddress } from "../../../commons/api";
import {
  Form,
  Col,
  Input,
  Drawer,
  Button,
  Card,
  Row,
  message,
  Popconfirm,
  Upload,
  Select,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  UploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

const { Option } = Select;

const NestedHierarchy = (props) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  // const location = useLocation();
  const [data,setData] = useState('');

  const nhRef = useRef(null);
  const [state, setState] = useState({
    visible: false,
    datasource: [],
    editObj: {},
    HierarchyName: "",
    ParentId: undefined,
    parentHierarchy: [],
    modalVisible: false,
    deviceList: [],
    selectedObject: {},
    value: [],
    translationCache: props.translationCache || [],
    devicesList: [],
    parentObject: null,
  });


  useEffect(() => {
    const pathSnippets = props.location.pathname
      .split("/rubus/settingsPage/Hierarchy/")
      .filter((i) => i);

    if (pathSnippets && pathSnippets[0]) {
      let hierarchyLevel = pathSnippets[0].split("/").filter((i) => i);
      let parentObject = props.location.state || null;
      let ParentId = parentObject && parentObject.Id ? parentObject.Id : null;

      _getHierarchyList(hierarchyLevel[0] || null, ParentId);
      setState(prev => ({
        ...prev,
        HierarchyName: hierarchyLevel[0],
        parentObject,
        ParentId,
      }));
    }
  }, []);

   useEffect(() => {
     handleDownload();
    }, [state.ParentId]);

  const _getHierarchyList = async (HierarchyName, ParentId) => {
    try {
      const accessToken = localStorage.get('accessToken');
      const siteId = localStorage.get('currentSite');
      const { data } = await axios({
        method: 'POST',
        url: `${API_HIERARCHYMODULE.GetById}?SiteId=${siteId}`,
        headers: { Authorization: `Bearer ${accessToken}` },
        data: { ParentId, HierarchyId: HierarchyName }
      });
      if (Array.isArray(data)) {
        setState(prev => ({
          ...prev,
          datasource: data,
          HierarchyName,
          ParentId,
        }));
      }
    } catch (error) {
      console.error("Error fetching hierarchy list:", error);
    }
  };
const handleDownload = async () =>{
    const siteId = localStorage.get('currentSite');
      const accessToken = localStorage.get('accessToken');
      let url = '';
      url = `${API_HIERARCHYMODULE.Hierarchyfiledownload}?SiteId=${siteId}&HierarchyId=${state.HierarchyName}&ParentId=${state.ParentId}`;
  
      let orgHeaders = {
        method: 'GET',
        url,
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      };
      return axios(orgHeaders)
        .then((response) => {
         setData(response.data.file);
        })
        .catch(function (error) {
          console.log(error);
        });
  };

  const openModal = () => {
    if (nhRef.current) {
      nhRef.current.resetFields();
    }
    setState((prevState) => ({
      ...prevState,
      visible: true,
      editObj: {},
    }));
  };

  const _cancel = () => {
    if (nhRef.current) {
      nhRef.current.resetFields();
    }
    setState((prevState) => ({
      ...prevState,
      visible: false,
      editObj: {},
    }));
  };

  // Edit Hierarchy
  const editHierarchy = (editObj) => {
    if (nhRef.current) {
      nhRef.current.setFieldsValue(editObj);
    }
    setState((prevState) => ({
      ...prevState,
      editObj,
      visible: true,
    }));
  };

  // Create Hierarchy
  const _createHierarchy = (e) => {
    const { HierarchyName, ParentId } = state;
    const siteId = localStorage.get("currentSite");
    e.preventDefault();

    nhRef.current
      .validateFields()
      .then(async (values) => {
        const payload = {
          ...values,
          HierarchyType: values.Next && values.Next === true ? 0 : 1,
          HierarchyId: HierarchyName,
          ParentId,
          SiteId: siteId,
        };
        _createHierarchyAPI(payload);
      })
      .catch(() => { });
  };

  // Create Hierarchy API Call
  const _createHierarchyAPI = (createObject) => {
    const { HierarchyName, parentObject } = state;
    const accessToken = localStorage.get("accessToken");
    const siteId = localStorage.get("currentSite");

    const orgCreateHeaders = {
      method: "POST",
      url: `${API_HIERARCHYMODULE.CREATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: createObject,
    };

    axios(orgCreateHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          message.success("Hierarchy Saved");
          _getHierarchyList(
            HierarchyName,
            parentObject && parentObject.Id ? parentObject.Id : null
          );
          setState((prevState) => ({
            ...prevState,
            visible: false,
          }));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Update Hierarchy
  const _updateHierarchy = (e) => {
    e.preventDefault();
    const { editObj } = state;

    nhRef.current
      .validateFields()
      .then(async (values) => {
        const updateObject = {
          ...values,
          HierarchyType: values.Next && values.Next === true ? 0 : 1,
          Id: editObj.Id,
        };
        _updateHierarchyAPI(updateObject);
      })
      .catch(() => { });
  };


  // Update Hierarchy API Call
  const _updateHierarchyAPI = (updateObject) => {
    const { HierarchyName, editObj, parentObject } = state;
    const accessToken = localStorage.get("accessToken");
    const siteId = localStorage.get("currentSite");

    const orgUpdateHeaders = {
      method: "POST",
      url: `${API_HIERARCHYMODULE.UPDATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: {
        ...editObj,
        ...updateObject,
      },
    };

    axios(orgUpdateHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          message.success("Hierarchy Updated");
          _getHierarchyList(
            HierarchyName,
            parentObject && parentObject.Id ? parentObject.Id : null
          );
          setState((prevState) => ({
            ...prevState,
            visible: false,
            editObj: {},
          }));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Delete Hierarchy
  const _deleteHierarchy = (payload) => {
    const { HierarchyName, parentObject } = state;
    const accessToken = localStorage.get("accessToken");
    const siteId = localStorage.get("currentSite");

    const orgDeleteHeaders = {
      method: "POST",
      url: `${API_HIERARCHYMODULE.DELETE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: payload,
    };

    axios(orgDeleteHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          message.success("Hierarchy Deleted");
          _getHierarchyList(
            HierarchyName,
            parentObject && parentObject.Id ? parentObject.Id : null
          );
          setState((prevState) => ({
            ...prevState,
            visible: false,
          }));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Navigation to Next Level
  const nextLevel = (record) => {
    const { HierarchyName, parentHierarchy, ParentId } = state;

    _getHierarchyList(
      HierarchyName,
      record && record.Id ? record.Id : null
    );

    const updatedParentHierarchy = [...parentHierarchy, ParentId];

    navigate({
      pathname: `/rubus/settingsPage/Hierarchy/${HierarchyName}/${record.Name}`,
    });

    setState((prevState) => ({
      ...prevState,
      parentObject: record,
      parentHierarchy: updatedParentHierarchy,
    }));
  };

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword]
      ? translationCache[keyword]
      : keyword;
  };


  const handleChange = (info) => {
    const { status } = info.file;
    if (status === "done") {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const beforeUpload = (file) => {
      const isLt10M = file.size / 1024 / 1024 < 10;
      const isCSV = file.type === 'text/csv' || file.name.endsWith('.csv');
        if (!isCSV) {
            message.error('You can only upload CSV files!');
        }
      if (!isCSV) {
        message.error("XLXS file must be smaller than 10MB!");
      }
      return isLt10M && isCSV;
    };
  

  const openDeviceModal = () => {
    deviceChange([]);
    _getDeviceList(state.parentObject);
    setState((prevState) => ({
      ...prevState,
      modalVisible: true
    }));
  };

  const _getDeviceList = (parentObject) => {
    const SiteId = localStorage.get("currentSite");
    let accessToken = localStorage.get("accessToken");
    const healthHeaders = {
      method: "GET",
      url: `${API_DEVICE.LIST}?SiteId=${SiteId}&ParentEquipment=${parentObject && parentObject.Type && parentObject.Type === "Device" ? parentObject && parentObject.Code ? parentObject.Code : null : null}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };

    axios(healthHeaders)
      .then((response) => {
        setState((prevState) => ({
          ...prevState,
          deviceList: response.data
        }));
      })
      .catch(() => { });
  };

  const onOk = () => {
    setState((prevState) => ({
      ...prevState,
      modalVisible: false
    }));
    _createHierarchyAPI(state.selectedObject);
  };

  const deviceChange = (value) => {
    const { deviceList, HierarchyName, parentObject } = state;

    let data = value.map((item) => {
      let innerObject = deviceList.find(selectedDevice => selectedDevice.Id === item);
      return innerObject ? {
        Name: innerObject.Name,
        Code: innerObject.DeviceCode,
        ShortDescription: "This is " + innerObject.Name + " Equipment",
        LongDescription: "This is " + innerObject.Name + " Equipment",
        HierarchyId: HierarchyName,
        ParentId: parentObject && parentObject.Id ? parentObject.Id : null,
        DeviceId: 1,
        Type: "Device",
        MainId: innerObject.Id,
        Next: false,
        HierarchyType: 1,
      } : {};
    }).filter(item => Object.keys(item).length > 0);

    let payload = {
      data,
      deviceSelection: true,
    };
    setState((prevState) => ({
      ...prevState,
      selectedObject: payload, 
      value
    }));
  };

  const _OnCancel = () => {
    if (nhRef.current) {
      nhRef.current.resetFields();
    }
    setState((prevState) => ({
      ...prevState,
      modalVisible: false,
      editObj: {},
    }));
  };

  const onFinishFailed = () => {
    message.error("please Input required fields");
  };

  const onTypeChange = async (value) => {
    const devicesList = await getDeviceList(value);  
    setState((prevState) => ({
      ...prevState,
      Type: value,
      devicesList : devicesList

    }));
    nhRef && nhRef.current && nhRef.current.setFieldsValue({
      Next : null,
    });
  };

  const getDeviceList = async (type) => {
    const accessToken = localStorage.get("accessToken");
    const siteId = localStorage.get("currentSite");
    let orgDeleteHeaders = {
      method: "GET",
      url: `${API_DEVICE.LIST}?SiteId=${siteId}&Type=${type}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return axios(orgDeleteHeaders)
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const columns = [
    {
      title: translation("Name"),
      dataIndex: "Name",
    },
    {
      title: translation("Code"),
      dataIndex: "Code",
    },
    {
      title: translation("Type"),
      dataIndex: "Type",
    },
    {
      title: translation("Action"),
      render: (text, record) => (
        <div>
          <Button
            type="primary"
            onClick={() => editHierarchy(record)}
            style={{ marginRight: "10px" }}
          >
            <EditOutlined />
          </Button>

          {record && record.Default && record.Default !== true ? (
            <Popconfirm
              title={translation("Are you sure delete Hierarchy ?")}
              onConfirm={(e) => {
                e.stopPropagation();
                _deleteHierarchy(record);
              }}
              okText={translation(constant.yes)}
              cancelText={translation(constant.no)}
            >
              <Button type="prmiary">
                <span>
                  <DeleteOutlined />
                </span>
              </Button>
            </Popconfirm>
          ) : null}

          {record.Next === true ? (
            <Button
              type="primary"
              onClick={() => nextLevel(record)}
              style={{ marginLeft: "10px" }}
            >
              {translation("Next Level")}
            </Button>
          ) : null}
        </div>
      ),
    },
  ];
  return (

    <div style={{ minHeight: window.innerHeight - 173 }}>
      <Drawer open={state.modalVisible} onClose={_OnCancel} closable>

        <Form.Item label={translation("Device")} name="Device">
          <Select
            mode="multiple"
            placeholder={translation("Please Select Equipment")}
            style={{ width: 350 }}
            value={state.value}
            onChange={(value) => deviceChange(value)}
          >
            {state.deviceList &&
              Array.isArray(state.deviceList) &&
              state.deviceList.map((device, index) => (
                <Option key={index} value={device.Id}>
                  {device.DisplayCode}-{device.DeviceCode}
                </Option>
              ))}
          </Select>
        </Form.Item>
        <DrawerFooter>
          <Button type="primary" shape="round" onClick={onOk}>
            {translation("Submit")}
          </Button>
        </DrawerFooter>
      </Drawer>
      <Card bordered={false}>
        <Drawer
          title={translation(!state.editObj.Id ? "Create Hierarchy" : "Update Hierarchy")}
          open={state.visible}
          width={600}
          closable
          onClose={_cancel}
        >
          <Form
            form={form}
            layout="vertical"
            name={"NestedHierarchyForm"}
            ref={nhRef}
            labelCol={{ span: 10 }}
            wrapperCol={{ span: 14 }}
            initialValues={state.editObj || {}}
            onFinishFailed={onFinishFailed}
          >
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item label={translation("Type")} name="Type">
                  <Select
                    placeholder={translation("Select Type")}
                    onChange={onTypeChange}
                  >
                    {/* <Option value={"Location"}>{translation("Location")}</Option> */}
                    <Option value={"Asset"}>{translation("Asset")}</Option>
                    <Option value={"Device"}>{translation("Device")}</Option>
                  </Select>
                </Form.Item>
                <Form.Item label={translation("Name")} name="Name">
                  <Input placeholder={translation("Input Name")} />
                </Form.Item>

                <Form.Item label={translation("Code")} name="Code">
                  {(nhRef.current &&
                    nhRef.current.getFieldsValue().Type &&
                    nhRef.current.getFieldsValue().Type === "Device") ||
                      (state && state.editObj && state.editObj.Type === "Device") ? (
                    <Select placeholder={translation("Select Device Code")}>
                      {state.devicesList &&
                        Array.isArray(state.devicesList) &&
                        state.devicesList.map((device, key) => (
                          <Option key={key} value={device.DeviceCode}>
                            {translation(device.DeviceCode)}
                          </Option>
                          )
                        )}
                    </Select>
                  ) : (
                    <Input placeholder={translation("Enter Code")} />
                  )}
                </Form.Item>
                <Form.Item label={translation("Short Description")} name="ShortDescription">
                  <Input placeholder={translation("Input Short Description")} />
                </Form.Item>
                <Form.Item label={translation("Long Description")} name="LongDescription">
                  <Input placeholder={translation("Input Long Description")} />
                </Form.Item>
                <Form.Item label={translation("Enable Next Level")} name="Next">
                  {(nhRef.current &&
                    nhRef.current.getFieldsValue().Type &&
                    nhRef.current.getFieldsValue().Type === "Asset") ||
                   (state && state.editObj && state.editObj.Type === "Asset") ? (
                  <Select placeholder={translation("Select Enable Next Level")}>
                    <Option value={true}>{translation("True")}</Option>
                    <Option value={false}>{translation("False")}</Option>
                  </Select>
                   ) : (
                    <Select placeholder={translation("Select Enable Next Level")} defaultValue={false}>
                     <Option value={false}>{translation("False")}</Option>
                   </Select>
                   )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <div style={{
            position: 'absolute',
            left: '0',
            bottom: '0',
            width: '100%',
            textAlign: 'center',
            paddingBottom: '10px'
          }}>
            <Button type="primary" onClick={_cancel} style={{ marginRight: 8 }}>
              {translation("Cancel")}
            </Button>
            {!state.editObj.Id ? (
              <Button type="primary" onClick={_createHierarchy}>
                {translation("Create")}
              </Button>
            ) : (
              <Button type="primary" onClick={_updateHierarchy}>
                {translation("Update")}
              </Button>
            )}
          </div>
        </Drawer>

        <Button
          type="primary"
          style={{ marginBottom: "10px", float: "right" }}
          onClick={openModal}
        >
          <PlusOutlined />
          {translation("Add")}{" "}
        </Button>

        <Button
          type="primary"
          style={{
            marginBottom: "10px",
            float: "right",
            marginRight: "10px",
          }}
          onClick={openDeviceModal}
        >
          {translation("Device Selection")}
        </Button>

        <Button
          type="primary"
          onClick={() => {
            props.navigate(-1);
          
            _getHierarchyList(
              state.HierarchyName,
              state && state.parentHierarchy[state.parentHierarchy.length - 1]
            );
            state.parentHierarchy.splice(-1, 1);
            setState((prevState) => ({
              ...prevState,
              parentHierarchy:state.parentHierarchy
            }));
          }}
        >
          {translation("Go back")}
        </Button>
        {state?.ParentId === null ?(null):(
              <>
        <Button
            type="primary"
            style={{
            marginBottom: "10px",
            float: "right",
            marginRight: "10px",
          }}
            >
              <a href={`${IPAddress.LOCAL}/api/downloads/configurations/${data}`}>
                <DownloadOutlined/>
                {translation('Download')}
              </a>
              
            </Button>

          <Button
              type="primary"
              style={{
              marginBottom: "10px",
              float: "right",
              marginRight: "10px",
            }}
              >
              <Upload
                name="file"
                action={`${API_HIERARCHYMODULE.Hierarchyfileupload}?SiteId=${localStorage.get("currentSite")}&HierarchyId=${state?.HierarchyName}&ParentId=${state?.ParentId}&ParentType=${state?.parentObject?.Type || null}`}
                multiple={false}
                headers={{
                  Authorization: `Bearer ${localStorage.get("accessToken")}`,
                }}
                beforeUpload={beforeUpload}
                onChange={handleChange}
              >
                <UploadOutlined/>
                {translation("Upload")}
              </Upload>
              </Button>
            </>
            )}
        <StyledTable size="small"
          columns={columns}
          dataSource={state && state.datasource ? state.datasource : []}
          pagination={
           state.datasource.length > 10
              ? {
                pageSize: "10",
              }
              : false
          }
        />
      </Card>
     
    </div>

  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(NestedHierarchy);